// extracted by mini-css-extract-plugin
export default {"wrapper":"basic-form__wrapper","basicForm":"basic-form__basicForm"};